import { useScrollReveal } from "../../hooks/useScrollReveal";

export default function Footer() {
  const [ref, visible] = useScrollReveal();

  return (
    <footer style={{
      borderTop: "1px solid rgba(255,255,255,0.06)",
      background: "#06080F",
      padding: "40px 24px",
    }}>
      <div
        ref={ref}
        style={{
          maxWidth: 1200, margin: "0 auto",
          display: "flex", alignItems: "center",
          justifyContent: "space-between", flexWrap: "wrap", gap: 16,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(14px)",
          transition: "opacity 0.65s ease, transform 0.65s ease",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <img
            src="/images/alphastack-logo-pVgok4VY (1).png"
            alt="AlphaStack"
            style={{ height: 26, objectFit: "contain", opacity: 0.75 }}
          />
          <span style={{
            fontSize: "0.75rem", color: "rgba(240,238,246,0.22)",
            fontFamily: "Space Grotesk, sans-serif",
            borderLeft: "1px solid rgba(255,255,255,0.08)", paddingLeft: 16,
          }}>
            Building the future of intelligent investing
          </span>
        </div>

        <p style={{
          fontSize: "0.73rem", color: "rgba(240,238,246,0.2)",
          fontFamily: "Space Grotesk, sans-serif", margin: 0,
        }}>
          © {new Date().getFullYear()} Alpha Stack · All rights reserved
        </p>
      </div>
    </footer>
  );
}
